/**
 * Want to store this in global object so we can make things null when they're done, so that they're not re-run whenever a user logs out
 */
const splashScreenTasks: {
	promises: Promise<any>[];
} = {
	promises: [],
};
export default splashScreenTasks;
